import { httpsCallable } from "firebase/functions";
import { cloudFunctions } from "./getFunctions";
import {
  EnviarMailInvitacion,
  CloudFunctionResponse,
  CallablesGeneral
} from "@fixeduy/restaurantestypes";

const enviarMailInvitacion = async (
  data: EnviarMailInvitacion
): Promise<CloudFunctionResponse> => {
  const run = httpsCallable<CallablesGeneral, CloudFunctionResponse>(
    cloudFunctions,
    "callablesGenerales"
  );
  const result = await run({
    func: "enviarMailInvitacion",
    params: data
  });
  return result.data;
};

export { enviarMailInvitacion };
